export default __webpack_public_path__ + "static/media/Image24.3c489f2a.png";